import Vue from 'vue'
import store from '@/store'
import axios from 'axios'

import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

if (localStorage.getItem('x-api-key')) {
  let key = localStorage.getItem('x-api-key')
  store.commit('setKey', key)
  Vue.axios.defaults.headers.common['x-api-key'] = key;
}
